<template>

<div>

	<app-header />


  <div class="container">

		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id">{{ project.name }}</router-link></li>
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id+'/tables'">{{ _lang('Collections') }}</router-link></li>
				<li class="breadcrumb-item active" aria-current="page">{{table.name}}</li>
			</ol>
		</nav>

      <div v-if="selected.length && posts.length>10" class="form-group text-right">
      	<label class="mr-2">{{ _lang('With selected:') }}</label>
      	<button class="btn btn-danger btn-sm" @click="deleteSelected">{{ _lang('Delete') }}</button>
      </div>


      <table class="table">
          <thead>
              <tr>
                  <th v-if="table.meta.includeDate">{{ _lang('Date') }}</th>
                  <th v-if="table.meta.includeTitle">{{ _lang('Title') }}</th>
                  <th v-if="table.meta.includeTitle">{{ _lang('Slug') }}</th>
                  <th v-for="field in displayedFields" :key="field.slug">{{field.name}}</th>
                  <th></th>
                  <th></th>
              </tr>
            </thead>
        <tbody>
          <tr v-for="post in posts" :key="post.id">
              <td v-if="table.meta.includeDate">{{dataBr(post.created_at)}} </td>
              <td v-if="table.meta.includeTitle">{{post.name}} </td>
              <td v-if="table.meta.includeTitle">{{post.slug}} </td>
              <td v-for="field in displayedFields" :key="field.slug">
                <div v-if="field.type=='image'">
                  <img :src="post_field(post,field)" style="max-height:50px">
                </div>
                <div v-else-if="field.type=='image-select'">
                  <img :src="post_field(post,field)" style="max-height:50px">
                </div>
                <div v-else-if="field.type=='file'">
                  {{ post_field(post,field).split('/').pop() }}
                </div>
                <div v-else-if="field.type=='checkbox'">
                  <span v-if="post_field(post,field)==1">{{field.name}}</span>
                </div>
                <div v-else-if="field.type=='textarea'">
                  {{ excerpt(post,field) }}
                </div>
                <div v-else-if="field.type=='wysiwyg'">
                  {{ excerpt(post,field) }}
                </div>
                <div v-else-if="field.type=='gallery'">
                  {{ post_field(post,field).length }}
                </div>
                <div v-else-if="field.type=='multiple-file'">
                  {{ post_field(post,field).length }}
                </div>
                <div v-else-if="field.type=='multiselect'">
                  {{ Array.from(post_field(post,field)).join(', ') }}
                </div>

                <div v-else>
                  {{ post_field(post,field) }}
                </div>
              </td>
              <td><router-link :to="'/project/'+project.id+'/table/'+table.id+'/browse/edit/'+post.id" class="btn btn-primary">{{ _lang('Edit') }}</router-link></td>
              <td><input type="checkbox" v-model="selected" :value="post.id"></td>
          </tr>
        </tbody>
      </table>

      <div v-if="selected.length" class="form-group text-right">
      	<label class="mr-2">{{ _lang('With selected:') }}</label>
      	<button class="btn btn-danger btn-sm" @click="deleteSelected">{{ _lang('Delete') }}</button>
      </div>

      <router-link :to="'/project/'+project.id+'/table/'+table.id+'/browse/new'" class="btn btn-primary">{{ _lang('New') }} {{table.meta.singular || table.name}}</router-link>
      <span class="btn btn-light" @click="goBack">{{ _lang('Back') }}</span>

    </div>

    <div class="container mt-5">
      <h4>Importar/exportar</h4>

      <p>Baixar template: <a :href="exportUrl(`csv`)">CSV</a> / <a :href="exportUrl(`json`)">JSON</a></p>

      <p>Importar: <input type="file" @change="onImport" /></p>

    </div>

</div>

</template>
<script>

import axios from 'axios';
import appHeader from '../components/appHeader.vue'

export default {
	props:['project_id','table_id'],
	components:{
    appHeader,
  },
  data() {
    return {
      table:{
        meta:{}
			},
			fields:[],
			posts:[],
			selected:[],
    }
	},
	computed:{
		project(){
			return this.$store.getters.project;
		},
		displayedFields(){
			// filter fields where meta.hideAtListing is true
			return this.fields.filter(field=>{
				if(!field.meta) return true;
				return !field.meta.hideAtListing;
			})
		}
	},
  methods:{
  	deleteSelected(){
  		if(!confirm(this._lang('Delete all selected posts?'))) return;

  		axios({
        method: 'delete',
        url: '/api/posts',
        data: {selected:this.selected}
      }).then((res) => {
				this.selected = [];
        this.getData();
        toastr(this._lang('Selected posts successfully deleted.'));
      });
  	},
    goBack(){
      // this.$router.go(-1);
      this.$router.push({ name: 'project-tables', params: { project_id:this.project_id} })
    },
    url(slug,page){
      var url = slug+'.'+process.env.VUE_APP_BASEURL;
      if(page) url += '/'+page.replace(/\/$/,'')
      return url;
    },
    exportUrl(format){
      return `//app.${process.env.VUE_APP_BASEURL}/api/tables/${this.table_id}/export/${format}`;
    },
    dataBr(data){
      var d = new Date(data);
      return ('0'+d.getDate()).substr(-2) + '/' +('0'+(d.getMonth()+1)).substr(-2)+'/'+d.getFullYear();
    },

    getData(){
      let table_id = this.table_id;
      axios({
          url: '/api/data/'+table_id,
      }).then((res) => {
          if(!res.data.table.meta) res.data.table.meta = {};
          this.table = res.data.table;
          this.fields = res.data.fields;
          this.posts = res.data.posts;
      });
    },

     post_field(post,field){
			 return post[field.slug] || '';
		},

		excerpt(post,field){
			var text = post[field.slug] || '';
			if(!text) return '';
			text = text.replace(/<[^>]+>/g,''); //remove html tags
			text = text.replace(/[\n\s]+/g,' ');
			if(text.length>60){
			  text = text.substr(0,60).trim()+'...';
			}
			return text;
		},

    onImport(event){

			var files = event.target.files || event.dataTransfer.files;

			var file = files[0];
			if(!file) return;
			event.target.value='';

			var reader = new FileReader();

      this.$store.dispatch('startLoading');

			reader.onload = (e) => {
				var base64 =  e.target.result;
				var data = {
					name:file.name,
					content:base64
				}

				axios.post(`/api/tables/${this.table_id}/import`,data)
				.then((response)=> {
          toastr(response.data + ' cadastros inseridos com sucesso');
          this.getData();
				})
				.catch((error) =>  {
					console.error(error);
					if(error.response) alert(error.response.data);
				})
				.finally(()=>{
          this.$store.dispatch('stopLoading');
        });
			};

			reader.readAsDataURL(file);

    }


  },
  mounted(){
    this.getData();
  }

}



</script>

<style>

</style>
